import "./Home.module.css";
import StudioEntrance from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TheMasterPrinterHub from "./sections/TheMasterPrinterHub";
import StudioServicesPreview from "./sections/StudioServicesPreview";
import DigitalDecorTeaser from "./sections/DigitalDecorTeaser";
import MainBlogPosts from "./sections/MainBlogPosts";
import StudioCredits from "@/reusable_sections/Footer";
import HomeHeroCarousel from "./sections/HomeHeroCarousel";
export default function HomePage() {
  return <div>
      <StudioEntrance />
      <HomeHeroCarousel />
      <StudioServicesPreview />
      <Hero />
      <TheMasterPrinterHub />
      <DigitalDecorTeaser />
      <MainBlogPosts />
      <StudioCredits />
    </div>;
}